import Header from "./Header"



export default function MainHeader() {
  return (
    <>
    <Header variant="main" />

    </>
  )
}
